<template>
  <div>
    <v-card class="pa-5">
      <module-header>Reporte Comensales</module-header>
      <v-overlay :value="loadingData">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-row>
        <v-col md="3" cols="12" class="input">
          <label>Fecha inicial</label>
          <Datepicker
            @selected="selectDate"
            :value="input_date.format('MM/DD/YYYY')"
          ></Datepicker>
        </v-col>
        <v-col md="3" class="input">
          <label>Fecha final</label>
          <Datepicker
            @selected="selectDateFinal"
            :disabled-dates="disableDates"
            :value="input_date_final.format('MM/DD/YYYY')"
          ></Datepicker>
        </v-col>
        <v-col md="2">
          <v-select
            v-model="depto"
            :items="departamentos"
            :menu-props="{ maxHeight: '400' }"
            item-text="Nombre"
            item-value="Id"
            label="Departamentos restaurante"
            persistent-hint
          ></v-select>
        </v-col>

        <v-col md="12" cols="12">
          <v-btn depressed @click="getAccounts()" color="success">
            Buscar
          </v-btn>
          <v-btn class="mx-1" color="red" @click="generatePdf()" dark
            >
            Generar pdf
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <div>
      <v-card class="mt-4">
        <v-simple-table class="pa-4" dense>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Cantidad comensales</th>
            </tr>
          </thead>
          <tbody v-if="parsedComensales">
            <template v-for="(fechas, index) in parsedComensales">
              <tr :key="index" style="background: #2185d03b;">
                <td>{{ fechas.fecha }}</td>
                <td>{{ fechas.ComensalesDia }}</td>
              </tr>
              <!-- Iterar sobre las horas de cada fecha -->
              <tr v-for="(hora, hIndex) in fechas.Horas" :key="hIndex">
                <td>{{ hora.hora }}</td>
                <td>{{ hora.comensales }}</td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <td>No hay información disponible</td>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteComensales from "../../../clases/PdfMakers/ReporteComensales.js"

export default {
  name: "ReporteComensales",
  data() {
    return {
      input_date: moment(),
      input_date_final: moment(),
      selectTurno: "ALL",
      loadingData: false,
      getAybCuentas: [],
      departamentos: [],
      depto: "first",

      data_ventas: [],
    };
  },
  components: { Datepicker },
  methods: {
    generatePdf(){
      let mainData = {
        TITLE: "Reporte Comensales",
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.parsedComensales,
      };
      let docData = ReporteComensales.getDocData(
        mainData
      );
      pdfmake.createPdf(docData).open();
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getDepartamentosAB() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "AYB/Departamentos"
      );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
      this.depto = this.departamentos[0].Id;
    },
    /** ---------------------------------------------------------------------- */
    async getAccounts() {
      this.loadingData = true
      this.getAybCuentas = [];

      const startDate = new moment(this.input_date).format(
        "YYYY-MM-DD 00:00:00"
      );
      const endDate = new moment(this.input_date_final).format(
        "YYYY-MM-DD 23:59:59"
      );
      const startMlsc = new moment(startDate).valueOf();
      const endMlsc = new moment(endDate).valueOf();

      let cuentas = [];

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("AYB_Cuentas", [
        firestore.where("FechaCreacion", ">=", startMlsc),
        firestore.where("FechaCreacion", "<", endMlsc),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("DAYB", "==", this.depto),
      ]);
      cuentas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      this.getAybCuentas = cuentas;
      this.loadingData = false;
    },

    /** ---------------------------------------------------------------------- */
  },
  computed: {
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    parsedComensales() {
  let groupComensales = {};
  
  this.getAybCuentas.forEach((cuenta) => {
    if(cuenta.Estatus != -1) {
    let fecha = moment(cuenta.FechaCreacion).format("YYYY-MM-DD");
    let hora = moment(cuenta.FechaCreacion).format("HH:00");

    if (!groupComensales[fecha]) {
      groupComensales[fecha] = {
        fecha: fecha,
        ComensalesDia: 0,
        Horas: []
      };
    }

    let comensales = cuenta.Comensales ? Number(cuenta.Comensales) : 1

    let horaEncontrada = groupComensales[fecha].Horas.find(h => h.hora === hora);
    if (horaEncontrada) {
      horaEncontrada.comensales += comensales
    } else {
      groupComensales[fecha].Horas.push({
        hora: hora,
        comensales: comensales
      });
    }

    groupComensales[fecha].ComensalesDia += comensales
    } 
  });

  // console.log(groupComensales);
  return groupComensales;
}

  },
  beforeMount: async function() {
    await this.getDepartamentosAB();
    await this.getAccounts();
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
